import { ReactNode } from "react";
import { makeStyles, createStyles, Button, Box, Theme } from "@material-ui/core";

export type CellActionProps = {
  title: string | ReactNode;
  action: () => void;
};

export const CellAction = ({ action, title }: CellActionProps) => {
  const classes = useStyles();
  return (
    <Box fontSize={12}>
      <Button className={classes.textSizeSmall} onClick={action} color="primary" size="small">
        {title}
      </Button>
    </Box>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    textSizeSmall: {
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit",
      padding: `0px ${theme.spacing(0.5)}px`,
    },
  }),
);
